import React from "react"
import autobind from "class-autobind"
import { TextField } from "material-ui"

interface IProps {
    field
    value
    onChange(key, value): void
}

interface IState {
}

export default class FormTextField extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        const field = this.props.field
        const value = this.props.value
        const onChange = this.props.onChange
       
        if(field.component === "ai-prompt"){
            return (
                <TextField
                style={{ width: "100%", fontFamily: "monospace" }}
                floatingLabelText={field.label}
                value={value || ""}
                multiLine
                fullWidth
                rows={4}
                rowsMax={10}
                onChange={(_e, value) => onChange(field.name, value)}
                />                   
            )
        }

        if(field.component === "multi-line-text-field"){
            return (
                <TextField
                style={{ width: "100%"}}
                floatingLabelText={field.label}
                value={value || ""}
                multiLine
                fullWidth
                rows={4}
                rowsMax={10}
                onChange={(_e, value) => onChange(field.name, value)}
                />                   
            )
        }        

        return (
          <TextField
              floatingLabelText={field.label}
              value={value || ""}
              style={{ width: 400 }}
              onChange={(_e, value) => onChange(field.name, value)}
          />                 
        )
    }
}